import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { type StartProgressionDialogViewModel } from './StartProgressionDialogViewModel'
import { StartProgressionDialog } from '@/features/jobs/details/components/JobProgressionCard/NoProgressionActions/StartProgressionDialog'

export interface StartProgressionDialogContainerProps {
  vm: StartProgressionDialogViewModel
}

export const StartProgressionDialogContainer = observer(
  function StartProgressionDialogContainer({
    vm,
  }: StartProgressionDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <StartProgressionDialog
        showing={vm.modal.showing}
        corporateMode={shellInfo.corporateMode}
        isReview={vm.isReview}
        isStartPending={vm.startJobProgression.pending}
        onClose={vm.modal.close}
        onStart={vm.startJobProgression}
      />
    )
  },
)
